<template>
	<van-popup v-model="showPopup" position="bottom" safe-area-inset-bottom @close="closePopup()">
		<div v-if="loading" class="loading-calender">
			<div class="van-loading van-loading--circular van-loading--vertical">
				<span class="van-loading__spinner van-loading__spinner--circular">
					<img src="@/assets/images/investor_appointment/loading.png" />
				</span>
				<span class="loading-text">{{ $t('加载中') }}...</span>
			</div>
		</div>
		<div v-else-if="columns.length == 0" class="empty-calendar">
			<m-empty content="暂无可约时间"></m-empty>
		</div>
		<van-picker
			v-else
			:title="$t('选择预约开始时间')"
			show-toolbar
			:columns="columns"
			:default-index="defaultIndex"
			class="appointment-picker"
			:confirm-button-text="$t('确定')"
			@confirm="onConfirm"
			@cancel="closePopup"
		/>
	</van-popup>
</template>

<script>
import { Popup, Picker } from 'vant';
import { irstore } from '@/fetch/interface';
import { useAppointmentDate } from './useAppointmentDate';
import { EN } from '@/assets/js/i18n';

export default {
	props: {
		visible: Boolean,
		conferenceTemplateId: [String, Number],
		initTime: Object
	},
	components: {
		'van-popup': Popup,
		'van-picker': Picker
	},
	data() {
		return {
			showPopup: false,
			loading: false,
			columns: [],
			defaultIndex: 0,
			selectedTime: { date: 0, startDate: null, endDate: null }
		};
	},
	watch: {
		visible: {
			handler(newVal) {
				this.showPopup = newVal;
				if (this.showPopup) {
					if (this.initTime) {
						this.selectedTime = this.initTime;
					}
					this.loadOptionalTime(this.initTime);
				}
			},
			immediate: true
		}
	},
	methods: {
		loadOptionalTime(currentTime) {
			if (!this.conferenceTemplateId) return;

			this.loading = true;
			this.$axios
				.post(
					irstore.getOptionalTime(this.conferenceTemplateId),
					{},
					{
						headers: {
							showLoading: false
						}
					}
				)
				.then(({ data }) => {
					if (data) {
						const { dateRangeVOList = [] } = data;
						const realSelectedDate = currentTime;

						this.columns = [];
						const tmpl = this.$i18n.locale === EN ? 'yyyy/MM/dd' : 'yyyy年MM月dd日';

						// 转换为 picker 需要的格式：根据 date、startDate、endDate 的存在情况展示
						this.columns = dateRangeVOList.map(item => {
							const text = this.formatAppointmentText(item.date, item.startDate, item.endDate, tmpl);

							return {
								text: text,
								value: {
									date: item.date,
									startDate: item.startDate || null,
									endDate: item.endDate || null
								}
							};
						});

						// 设置默认选中的索引
						if (realSelectedDate) {
							// 完整匹配时间格式字符串
							const selectTmpl = `${realSelectedDate.date}/${realSelectedDate.startDate}/${realSelectedDate.endDate}`;
							const selectedIndex = this.columns.findIndex(
								item => `${item.value.date}/${item.value.startDate}/${item.value.endDate}` == selectTmpl
							);

							this.defaultIndex = selectedIndex == -1 ? 0 : selectedIndex;
							this.selectedTime = this.columns[this.defaultIndex]?.value || {
								date: 0,
								startDate: null,
								endDate: null
							};
						} else {
							this.defaultIndex = 0;
							this.selectedTime = this.columns[0]?.value || {
								date: 0,
								startDate: null,
								endDate: null
							};
						}

						if (!realSelectedDate) {
							this.$emit('confirm', { time: { date: 0, startDate: null, endDate: null } });
						}
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onConfirm({ value }) {
			this.selectedTime = value;
			this.$emit('confirm', {
				time: this.selectedTime
			});
			this.closePopup();
		},
		closePopup() {
			this.$emit('update:visible', false);
			this.defaultIndex = 0;
			this.selectedTime = { date: 0, startDate: null, endDate: null };
		}
	},
	setup() {
		const { formatAppointmentText } = useAppointmentDate();

		return {
			formatAppointmentText
		};
	}
};
</script>

<style lang="less" scoped>
@import '@/style/mixin/mixins.less';
@import '@/style/mixin/border-radius.less';

.loading-calender,
.empty-calendar {
	height: 3.215rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.loading-calender {
	.loading-text {
		margin-top: 0.1rem;
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.14rem;
		font-weight: 400;
	}
}

.appointment-picker {
	/deep/ .van-picker__cancel {
		display: none;
	}
	/deep/ .van-picker__title {
		padding-left: 0.14rem;
		color: #333;
		font-size: 0.15rem;
		font-weight: 500;
	}
	/deep/ .van-picker__confirm {
		color: var(--ir-theme-color);
	}
}
</style>
